export const translations = {
  en: {
    name: "Name",
    phoneNumber: "Phone number",
    number: "Number",
    phoneNumberPlaceholder: "Phone number",
    phoneNumberHelp: "Enter phone number (e.g., +49 123 4567890 or 0151 2345678)",
    phoneNumberInvalidChars: "Only + and numbers allowed",
    phoneNumberInvalidLength: "Phone number must be 7-15 digits long",
    voiceAgentTitle: "Voice Agent",
    voiceAgentKey: "Name",
    defaultAgentName: "Unnamed Agent",
    sipEndpoint: "Phone number/SIP Endpoint",
    editNode: "Edit node",
    settings: "Settings",
    save: "Save flow",
    notice: "Notice",
    warning: "Warning",
    field: "Field",
    maxPromptConnectionWarning: "An intent can only have one prompt connection. Please remove the existing connection before adding a new one.",
    maxPhonePromptConnectionWarning: "A phone number can only have one initial prompt. If you want to change the initial prompt, please remove the existing connection first.",
    promptToPromptWarning: "Cannot connect a prompt to another prompt. Prompts should be connected through intent nodes.",
    intentToIntentWarning: "Cannot connect an intent to another intent. Intents should be connected to prompt nodes.",
    functionToFunctionWarning: "Cannot connect a function to another function. Functions should be connected to prompt nodes.",
    sameTypeConnectionWarning: "Cannot connect nodes of the same type. Please connect different types of nodes.",
    intentNameValidationError: "Intent name contains invalid characters. Intent names cannot contain double quotes, single quotes, backslashes, or other special characters. Please use only letters, numbers, spaces, hyphens, and underscores.",
    unconnectedNodesWarning: "There are nodes without connections. Please connect all nodes before saving or delete unconnected nodes.",
    controlCharacterWarning: "Invalid hidden characters detected. This often happens when copying from PDFs or Word. Please retype the text or paste through a plain text editor first.",
    phoneValidationError: "Invalid phone number detected. Please correct the phone number before saving.",
    speakFieldRequired: "The 'Speak' field is required for intents that are not connected to a prompt. Please fill in what the assistant should say.",
    numberNode: {
      selectedPrompt: "Selected start prompt"
    },
    promptNode: {
      title: "Prompt",
      content: "Content",
      unnamedPrompt: "New prompt",
      initialMessage: "Initial message",
      systemInstruction: "System instruction",
      systemInstructionNotice: "System instructions are set per prompt and are sticky—they apply to the whole session from the moment they're activated. They persist until explicitly overridden or updated by another prompt. If no new instruction is given, the previous one remains active.",
      systemInstructionPlaceholder: "e.g. You are a German-speaking phone assistant. Speak exclusively in German.\n\ne.g. When the user mentions a phone number, repeat it in German words, digit by digit.\nExample: 0676 1234567 → zero six seven six one two three four five six seven.\n\ne.g. If you don't understand something, ask specifically.\nExample: Instead of \"Can you repeat that?\" say: \"Could you please state your street name again?\"",
      containsStickyInstruction: "Contains sticky system instruction"
    },
    toolNode: {
      title: "Tool",
      description: "Function definition",
      readOnlyNotice: "Tools can be controlled from the Tools menu."
    },
    intentNode: {
      title: "Intent",
      unnamedIntent: "New intent",
      content: "Content",
      nextPrompt: "Next prompt",
      forwardPhone: "Forward to phone number",
      speak: "Speak",
      noPromptSelected: "---",
      connectionInstructions: "Connect using visual edges",
      dragPromptExplanation: "To connect this intent to a prompt, drag an edge from the bottom handle to the target prompt.",
      promptConnectedNotice: "This intent leads to a prompt node, so the speak and forward options are disabled. These options are only used when the intent forwards to a phone number instead of continuing the conversation."
    },
    existingPrompts: "Available Prompts",
    nodeTypes: "Node Types",
    functionCount: "functions",
    loadingPrompts: "Loading prompts...",
    muteUser: "Mute user during assistant speech",
    muteAll: "Mute All",
    unmuteAll: "Unmute All",
    toggleMuteAllPrompts: "Toggle mute for all prompt nodes",
    globalSettings: "Global Settings"
  },
  de: {
    name: "Name",
    phoneNumber: "Telefonnummer",
    number: "Nummer",
    phoneNumberPlaceholder: "Telefonnummer",
    phoneNumberHelp: "Telefonnummer eingeben (z.B. +49 123 4567890 oder 0151 2345678)",
    phoneNumberInvalidChars: "Nur + und Zahlen erlaubt",
    phoneNumberInvalidLength: "Telefonnummer muss 7-15 Ziffern lang sein",
    voiceAgentTitle: "Voice Agent",
    voiceAgentKey: "Name",
    defaultAgentName: "Unbenannter Agent",
    sipEndpoint: "Rufnummer/SIP Endpunkt",
    editNode: "Knoten bearbeiten",
    settings: "Einstellungen",
    save: "Flow speichern",
    notice: "Hinweis",
    warning: "Warnung",
    field: "Feld",
    maxPromptConnectionWarning: "Eine Absicht kann nur eine Anweisungsverbindung haben. Bitte entfernen Sie die bestehende Verbindung, bevor Sie eine neue hinzufügen.",
    maxPhonePromptConnectionWarning: "Eine Telefonnummer kann nur eine initiale Anweisung haben. Wenn Sie die initiale Anweisung ändern möchten, entfernen Sie bitte zuerst die bestehende Verbindung.",
    promptToPromptWarning: "Eine Anweisung kann nicht mit einer anderen Anweisung verbunden werden. Anweisungen sollten über Absichtsknoten verbunden werden.",
    intentToIntentWarning: "Eine Absicht kann nicht mit einer anderen Absicht verbunden werden. Absichten sollten mit Anweisungsknoten verbunden werden.",
    functionToFunctionWarning: "Ein Tool kann nicht mit einem anderen Tool verbunden werden. Tools sollten mit Anweisungsknoten verbunden werden.",
    sameTypeConnectionWarning: "Knoten des gleichen Typs können nicht miteinander verbunden werden. Bitte verbinden Sie unterschiedliche Knotentypen.",
    intentNameValidationError: "Der Absichtsname enthält ungültige Zeichen. Absichtsnamen dürfen keine Anführungszeichen, Apostrophe, Backslashes oder andere Sonderzeichen enthalten. Bitte verwenden Sie nur Buchstaben, Zahlen, Leerzeichen, Bindestriche und Unterstriche.",
    unconnectedNodesWarning: "Es gibt Knoten ohne Verbindungen. Bitte verbinden Sie alle Knoten vor dem Speichern oder löschen Sie nicht verbundene Knoten.",
    controlCharacterWarning: "Ungültige versteckte Zeichen erkannt. Dies passiert oft beim Kopieren aus PDFs oder Word. Bitte tippen Sie den Text neu oder fügen Sie ihn zuerst über einen einfachen Texteditor ein.",
    phoneValidationError: "Ungültige Telefonnummer erkannt. Bitte korrigieren Sie die Telefonnummer vor dem Speichern.",
    speakFieldRequired: "Das Feld 'Spreche' ist erforderlich für Absichten, die nicht mit einer Anweisung verbunden sind. Bitte füllen Sie aus, was der Assistent sagen soll.",
    numberNode: {
      selectedPrompt: "Ausgewählte Start-Anweisung"
    },
    promptNode: {
      title: "Anweisung",
      name: "Name",
      content: "Inhalt",
      unnamedPrompt: "Neue KI-Anweisung",
      initialMessage: "Initiale Nachricht",
      systemInstruction: "System-Anweisung",
      systemInstructionNotice: "System-Anweisungen werden pro Prompt festgelegt und bleiben aktiv - sie gelten für die gesamte Sitzung ab dem Moment ihrer Aktivierung. Sie bleiben bestehen, bis sie explizit durch einen anderen Prompt überschrieben oder aktualisiert werden. Wenn keine neue Anweisung gegeben wird, bleibt die vorherige aktiv.",
      systemInstructionPlaceholder: "z.B. Du bist ein deutschsprachiger Telefonassistent. Sprich ausschließlich auf Deutsch.\n\nz.B. Wenn der Nutzer eine Telefonnummer nennt, gib sie in deutschen Wörtern, Ziffer für Ziffer, wieder.\nBeispiel: 0676 1234567 → null sechs sieben sechs eins zwei drei vier fünf sechs sieben.\n\nz.B. Wenn du etwas nicht verstehst, frage gezielt nach.\nBeispiel: Statt \"Können Sie das wiederholen?\" sage: \"Könnten Sie bitte Ihre Straße noch einmal nennen?\"",
      containsStickyInstruction: "Enthält sticky System-Anweisung"
    },
    toolNode: {
      title: "Tool",
      description: "Tool- Definition",
      readOnlyNotice: "Tools können über das Tools-Menü gesteuert werden."
    },
    intentNode: {
      title: "Absicht",
      unnamedIntent: "Neue Absicht",
      content: "Inhalt",
      nextPrompt: "Nächste Anweisung",
      forwardPhone: "Weiterleiten an Telefonnummer",
      speak: "Spreche",
      noPromptSelected: "---",
      connectionInstructions: "Mit visuellen Kanten verbinden",
      dragPromptExplanation: "Um diese Absicht mit einer Anweisung zu verbinden, ziehen Sie eine Kante vom unteren Griff zur Zielanweisung.",
      promptConnectedNotice: "Diese Absicht leitet zu einer Anweisung weiter, daher sind die Sprach- und Weiterleitungsoptionen deaktiviert. Diese Optionen werden nur verwendet, wenn die Absicht an eine Telefonnummer weiterleitet anstatt das Gespräch fortzusetzen."
    },
    existingPrompts: "Verfügbare Anweisungen",
    nodeTypes: "Knotentypen",
    functionCount: "Tools",
    loadingPrompts: "Anweisungen werden geladen...",
    muteUser: "Nutzer während der Assistentenansprache stummschalten",
    muteAll: "Den Nutzer in allen Anweisungen stummschalten",
    unmuteAll: "Stummschaltung für alle Anweisungen aufheben",
    toggleMuteAllPrompts: "Stumm-Modus für alle Anweisungen umschalten",
    globalSettings: "Globale Einstellungen"
  },
};

export const getTranslation = (locale, key) => {
  const keys = key.split('.');
  let translation = translations[locale] || translations.en;
  
  for (const k of keys) {
    translation = translation[k];
    if (!translation) return key;
  }
  
  return translation;
}; 